"use client";

import { ArrowRight, Download, TrendingUp, Settings } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Analyticsdashboard() {
  const isAdmin = false;
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: chartRef,
    isVisible: chartVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: tableRef,
    isVisible: tableVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const seasonData = [{
    season: "Januari",
    value: 45
  }, {
    season: "Februari",
    value: 58
  }, {
    season: "Maret",
    value: 72
  }, {
    season: "April",
    value: 88
  }, {
    season: "Mei",
    value: 95
  }, {
    season: "Juni",
    value: 82
  }, {
    season: "Juli",
    value: 65
  }];
  const neighborhoods = [{
    name: "Redaksi Pusat Jakarta",
    hives: 12,
    honey: 450,
    score: 98
  }, {
    name: "Biro Jawa Barat",
    hives: 8,
    honey: 320,
    score: 95
  }, {
    name: "Biro Garut",
    hives: 6,
    honey: 280,
    score: 92
  }, {
    name: "Biro Jawa Tengah",
    hives: 5,
    honey: 210,
    score: 89
  }, {
    name: "Biro Jawa Timur",
    hives: 4,
    honey: 190,
    score: 85
  }];
  return <section data-section-id="955" id="analyticsdashboard" className="bg-background text-foreground py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`max-w-4xl mb-16 md:mb-20 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-primary" />
            <span className="font-mono text-xs tracking-[0.2em] text-primary uppercase">
              Data Statistik · Pembaruan Real-time
            </span>
          </div>
          <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight">
            Jangkauan nasional,{" "}
            <em className="text-primary not-italic font-light italic">
              terukur dan transparan
            </em>
          </h2>
        </div>

        {isAdmin && <>
            <div className="mb-12">
              <div className="bg-card border border-border rounded-lg p-8 shadow-md flex flex-col md:flex-row md:items-center justify-between gap-6">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <Settings className="size-5 text-primary" />
                    <h3 className="font-serif font-default text-2xl">ABADI Adjust Views</h3>
                  </div>
                  <p className="text-muted-foreground text-sm">
                    Kelola penyesuaian jumlah views artikel berdasarkan bulan dan tahun.
                  </p>
                </div>
                <Button asChild className="rounded-md">
                  <Link to="/wp-admin/tools.php?page=abadi-adjust-views">
                    Buka Tool Views
                  </Link>
                </Button>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 mb-12">
              <div ref={chartRef} className={`bg-card border border-border rounded-lg p-6 md:p-8 transition-all duration-700 shadow-md ${chartVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
                <div className="flex items-start justify-between mb-8">
                  <div>
                    <div className="font-mono text-[11px] tracking-[0.18em] text-muted-foreground uppercase mb-2">
                      Indeks Pertumbuhan
                    </div>
                    <h3 className="font-serif font-default text-2xl md:text-3xl leading-tight">
                      Aktivitas pembaca bulanan
                    </h3>
                  </div>
                  <span className="font-mono text-[10px] tracking-wider text-muted-foreground uppercase whitespace-nowrap">
                    2024
                  </span>
                </div>

                <div className="relative h-64 md:h-72">
                  <div className="absolute inset-0 flex flex-col justify-between pointer-events-none">
                    {[100, 75, 50, 25, 0].map((g, i) => <div data-index={i} key={i} className="flex items-center gap-2">
                        <span className="font-mono text-[10px] text-muted-foreground w-6">
                          {g}
                        </span>
                        <div className="flex-1 border-t border-border/40" />
                      </div>)}
                  </div>

                  <div className="absolute inset-0 pl-8 flex items-end justify-between gap-2 md:gap-3">
                    {seasonData.map((d, i) => <div data-index={i} key={i} className="flex-1 flex flex-col items-center justify-end h-full">
                        <div className="w-full rounded-md transition-all duration-1000 ease-out bg-gradient-to-br from-orange-500 to-orange-300" style={{
                    height: chartVisible ? `${d.value}%` : "0%",
                    transitionDelay: `${i * 80}ms`
                  }} />
                      </div>)}
                  </div>
                </div>

                <div className="mt-4 pl-8 flex justify-between gap-2">
                  {seasonData.map((d, i) => <span data-index={i} key={i} className="flex-1 text-center font-mono text-[9px] md:text-[10px] tracking-wider text-muted-foreground uppercase">
                      {d.season.substring(0, 3)}
                    </span>)}
                </div>
              </div>

              <div ref={tableRef} className={`bg-card border border-border rounded-lg p-6 md:p-8 transition-all duration-700 delay-100 shadow-md ${tableVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
                <div className="flex items-start justify-between mb-8">
                  <div>
                    <div className="font-mono text-[11px] tracking-[0.18em] text-muted-foreground uppercase mb-2">
                      Jaringan Biro
                    </div>
                    <h3 className="font-serif font-default text-2xl md:text-3xl leading-tight">
                      Performa per wilayah
                    </h3>
                  </div>
                </div>

                <Table>
                  <TableHeader>
                    <TableRow className="border-border hover:bg-transparent">
                      <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4">
                        Lokasi Biro
                      </TableHead>
                      <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4 text-right">
                        Tim
                      </TableHead>
                      <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4 text-right">
                        Berita
                      </TableHead>
                      <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4 text-right">
                        Skor
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {neighborhoods.map((n, i) => <TableRow data-index={i} key={i} className={`border-border/40 hover:bg-primary/5 ${i % 2 === 0 ? "bg-primary/[0.02]" : ""}`}>
                        <TableCell className="py-5 font-default text-sm">
                          {n.name}
                        </TableCell>
                        <TableCell className="py-5 text-right font-mono text-sm tabular-nums">
                          {n.hives}
                        </TableCell>
                        <TableCell className="py-5 text-right font-mono text-sm tabular-nums">
                          {n.honey}
                        </TableCell>
                        <TableCell className="py-5 text-right">
                          <span className="inline-flex items-center gap-1.5 font-mono text-sm tabular-nums text-primary">
                            {n.score}
                          </span>
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </div>
            </div>

            <div className="flex justify-end">
              <Button asChild variant="link" className="font-mono text-xs tracking-[0.15em] uppercase text-foreground hover:text-primary px-0">
                <Link to="/NewsPage">
                  <Download className="size-3.5 mr-2" />
                  Unduh laporan lengkap (PDF)
                  <ArrowRight className="size-3.5 ml-1" />
                </Link>
              </Button>
            </div>
          </>}
      </div>
    </section>;
}